import React, { useState } from 'react';
import { ArrowLeft, ArrowRightLeft, Calendar, Users } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
interface FlightSearchScreenProps {
  onBack: () => void;
  onSearch: () => void;
}
export function FlightSearchScreen({
  onBack,
  onSearch
}: FlightSearchScreenProps) {
  const [from, setFrom] = useState('Dakar (DSS)');
  const [to, setTo] = useState('');
  const [passengers, setPassengers] = useState(1);
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-300">
      <header className="bg-[#003366] px-6 pt-12 pb-6 sticky top-0 z-10 flex items-center gap-4" data-id="element-301">
        <button onClick={onBack} className="p-2 hover:bg-white/10 rounded-full transition-colors" data-id="element-302">
          <ArrowLeft size={24} className="text-white" data-id="element-303" />
        </button>
        <h1 className="text-xl font-bold text-white" data-id="element-304">Réserver un vol</h1>
      </header>

      <div className="flex-1 px-6 py-6 space-y-6" data-id="element-305">
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 space-y-6" data-id="element-306">
          {/* Route */}
          <div className="relative space-y-4" data-id="element-307">
            <div data-id="element-308">
              <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5 block" data-id="element-309">
                Départ
              </label>
              <Input value={from} onChange={e => setFrom(e.target.value)} className="font-medium" data-id="element-310" />
            </div>

            <button className="absolute top-[50%] right-4 -mt-2 p-2 bg-gray-100 rounded-full text-[#D4A017] hover:bg-[#D4A017] hover:text-white transition-colors z-10 border-2 border-white" data-id="element-311">
              <ArrowRightLeft size={16} data-id="element-312" />
            </button>

            <div data-id="element-313">
              <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5 block" data-id="element-314">
                Destination
              </label>
              <Input value={to} onChange={e => setTo(e.target.value)} placeholder="Ville ou aéroport" className="font-medium" autoFocus data-id="element-315" />
            </div>
          </div>

          {/* Dates */}
          <div className="grid grid-cols-2 gap-4" data-id="element-316">
            <div data-id="element-317">
              <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5 block" data-id="element-318">
                Aller
              </label>
              <div className="relative" data-id="element-319">
                <Input type="date" className="font-medium" data-id="element-320" />
                <Calendar className="absolute right-3 top-3 text-gray-400 pointer-events-none" size={18} data-id="element-321" />
              </div>
            </div>
            <div data-id="element-322">
              <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5 block" data-id="element-323">
                Retour
              </label>
              <div className="relative" data-id="element-324">
                <Input type="date" className="font-medium text-gray-400" disabled data-id="element-325" />
                <Calendar className="absolute right-3 top-3 text-gray-300 pointer-events-none" size={18} data-id="element-326" />
              </div>
            </div>
          </div>

          {/* Passengers */}
          <div data-id="element-327">
            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5 block" data-id="element-328">
              Passagers
            </label>
            <div className="flex items-center justify-between p-3 border border-gray-200 rounded-xl" data-id="element-329">
              <div className="flex items-center gap-3 text-gray-700" data-id="element-330">
                <Users size={20} data-id="element-331" />
                <span className="font-medium" data-id="element-332">
                  {passengers} Adulte{passengers > 1 ? 's' : ''}
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-333">
                <button onClick={() => setPassengers(Math.max(1, passengers - 1))} className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 hover:bg-gray-200" data-id="element-334">
                  -
                </button>
                <button onClick={() => setPassengers(passengers + 1)} className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 hover:bg-gray-200" data-id="element-335">
                  +
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-6 bg-white border-t border-gray-100 mt-auto" data-id="element-336">
        <Button fullWidth size="lg" onClick={onSearch} data-id="element-337">
          Rechercher des vols
        </Button>
      </div>
    </div>;
}